/**
 * Constantes para la página de confirmación de pago
 */

export const WHATSAPP_NUMBER = '59895454544';

export const PAYMENT_LINK = 'https://mpago.la/1nk1EWM';

export const PAYMENT_STATUS = {
  SUCCESS: 'success',
  PENDING: 'pending',
  FAILURE: 'failure',
  WAITING: 'waiting',
};

export const STATUS_MAPPING = {
  approved: PAYMENT_STATUS.SUCCESS,
  success: PAYMENT_STATUS.SUCCESS,
  pending: PAYMENT_STATUS.PENDING,
  rejected: PAYMENT_STATUS.FAILURE,
  failure: PAYMENT_STATUS.FAILURE,
};

